import { motion } from "framer-motion";

const LETTERS = "Ginius".split("");

export function GiniusWordmark({ className = "", dot = true, goldBorder = false }) {
  const goldStyle = goldBorder
    ? { WebkitTextStroke: "1.5px #D4AF5A", textShadow: "0 1px 0 rgba(212,175,90,0.35), 0 0 16px rgba(212,175,90,0.30)" }
    : undefined;
  const stagger = 0.11;
  const revealEnd = LETTERS.length * stagger + 0.5;
  return (
    <div className="relative inline-block">
      {/* Apparizione graduale da sinistra a destra + doppio battito finale */}
      <motion.div
        className={`font-brand font-bold leading-none relative inline-flex ${className}`}
        style={goldStyle}
        initial={{ scale: 1 }}
        animate={{ scale: [1, 1.06, 1, 1.04, 1] }}
        transition={{ delay: revealEnd, duration: 0.7, ease: "easeInOut", times: [0, 0.28, 0.5, 0.74, 1] }}
      >
        {LETTERS.map((ch, i) => (
          <motion.span
            key={i}
            className="inline-block"
            initial={{ opacity: 0, x: -18, filter: "blur(8px)" }}
            animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
            transition={{ delay: i * stagger, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          >
            {ch}
          </motion.span>
        ))}
        {dot && (
          <motion.span className="inline-block text-[#D4AF5A]" style={{ WebkitTextStroke: 0 }}
            initial={{ opacity: 0, scale: 0.4 }}
            animate={{ opacity: 1, scale: [0.4, 1.4, 1] }}
            transition={{ delay: revealEnd - 0.1, duration: 0.6, ease: "easeOut" }}>.</motion.span>
        )}
      </motion.div>
    </div>
  );
}
